module.exports = __webpack_public_path__ + "media/fonts/FontAwesome-91f80bba1dfc26a3fa4cf0cde498924d.otf";